import React from "react";

// MUI Components:
import { Radio,RadioGroup,FormControlLabel,Box } from "@mui/material";

// Context
// import { useFilter, useFilterDispatch } from '../../Context/FilterCountext';

// translation
import { useTranslation } from 'react-i18next';


function SorterBlock({onSorterChange, sortParam}) {

    const { t, i18n }     = useTranslation();


return(
    <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        value={sortParam}
        onChange={ (oEvent) => onSorterChange(oEvent.target.value)}
        name="radio-buttons-group">
        <FormControlLabel value="dat" control={<Radio />} label={t('filterbar.l_sort_date')} />
        <FormControlLabel value="loc" control={<Radio />} label={t('filterbar.l_sort_loc')} />
        <FormControlLabel value="prc" control={<Radio />} label={t('filterbar.l_sort_prc')} />
    </RadioGroup>

)
}

export default SorterBlock;